var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 flex flex-col p-4 -m-4",class:{
    'overflow-y-auto': _vm.scrollable,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }